import React from "react";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import type { CardProps } from "@mui/material/Card";
import Typography from "@mui/material/Typography";

import { IContent } from ".";
import { CardStyled } from "./cardStyle";

interface ICustomCardComponent extends Omit<CardProps, "title" | "content"> {
  title?: string | React.ReactNode;
  title1?: string;
  children?: React.ReactNode;
  content?: IContent[];
  option?: React.ReactNode;
  Image?: React.ReactNode;
}

const CustomCardComponent = React.forwardRef<
  HTMLDivElement,
  ICustomCardComponent
>(
  (
    {
      title,
      title1,
      content,
      children,
      option,
      Image,
      className,
      ...restProps
    },
    ref
  ) => {
    return (
      <CardStyled>
        <Box ref={ref} className="JobCard">
          <Card
            {...restProps}
            className={["CardData", className].filter(Boolean).join(" ")}
          >
            {content ? (
              content.map((item) => {
                return (
                  <Box key={item.id}>
                    <Typography variant="h3" className="LastWeekData">
                      {item.title}
                    </Typography>
                    <div className="jobRole">{item.children}</div>
                  </Box>
                );
              })
            ) : (
              <Box>
                <Typography variant="h3" className="LastWeekData">
                  {title && (
                    <span data-testid="card-title" className="heading-title">
                      {title}
                    </span>
                  )}
                  {option}
                  {Image}
                </Typography>
                <div className="jobRole">{children}</div>
              </Box>
            )}
          </Card>
        </Box>
      </CardStyled>
    );
  }
);

CustomCardComponent.displayName = "CustomCardComponent";

export default CustomCardComponent;
